import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { UserAuthenticatedLayout } from "@/layouts/AuthenticatedLayout/UserAuthenticatedLayout";
import { EmptyList } from "@/modules/theme/components/EmptyList/EmptyList";
import { PageMeta } from "@/modules/theme/components/PageMeta";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

const translationNamespace = "pages/HandbooksPage";

export const EmptyHandbooksView = () => {
  const { t } = useTranslation(translationNamespace);

  const classes = createEmptyHandbooksViewStyles(useTheme());

  return (
    <UserAuthenticatedLayout containerClassName={classes.root}>
      <PageMeta title={t("Handbooks")} />

      <Typography variant="pageHeading" className={classes.heading}>
        {t("Handbooks")}
      </Typography>

      <EmptyList heading={t("No handbooks!")}>
        <>
          <Typography variant="contentMedium" className={classes.emptyListText}>
            {t("Currently there are no handbooks available for you")}
          </Typography>
        </>
      </EmptyList>
    </UserAuthenticatedLayout>
  );
};

function createEmptyHandbooksViewStyles({ spacing }: Theme) {
  return {
    root: css({
      position: "relative",
    }),

    heading: css({
      marginBottom: spacing(3),
    }),

    emptyListText: css({
      textAlign: "center",
      marginBottom: spacing(2),
    }),
  };
}
